import React from "react";
import Style from "../../style/travel.module.scss";
import TravelBanner from "./TravelBanner";
import TravelTabForm from "./TravelTabForm";
import TravelWork from "./TravelWork";
import TravelPopular from "./TravelPopular";
import TravelAgent from "./TravelAgent";
import TravelDetail from "./TravelDetail";
import TravelCity from "./TravelCity";

const Travel = () => {
  return (
    <div className={Style.container}>
      <TravelBanner />
      <TravelTabForm />
      <TravelWork />
      <TravelPopular />;
      <TravelAgent />
      <TravelDetail />
      <TravelCity />
    </div>
  );
};

export default Travel;
